import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-abono-factura',
  templateUrl: './abono-factura.component.html',
  styleUrls: ['./abono-factura.component.scss']
})
export class AbonoFacturaComponent implements OnInit {

  newForm: FormGroup;

  /**
   * Constructor 
   * 
   * @param _data 
   * @param {MatDialogRef<AbonoFacturaComponent>} _dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) public _data, 
    public _dialog: MatDialogRef<AbonoFacturaComponent>
  ) 
  {
    this.newForm = this.createForm();
    console.log(_data);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup {
    return new FormGroup({
      no_factura: new FormControl(this._data.NoFactura),
      abono: new FormControl(this._data.abono ? {value: this._data.abono, disabled: true} : '', [
        Validators.pattern('^[0-9]{1,3}([.]?[0-9]{3})?([.]?[0-9]{3})?$')
      ])
    });
  }

}